import { ModuleWithProviders, NgModule } from '@angular/core';
import { FacebookPixelService } from './shared/facebook-pixel.service';

export interface FacebookPixelConfiguration {
  enabled: boolean;
  facebookPixelId: string;
}

@NgModule({
  imports: [],
})
export class FacebookPixelModule {
  static forRoot(config: FacebookPixelConfiguration): ModuleWithProviders<FacebookPixelModule> {
    return {
      ngModule: FacebookPixelModule,
      providers: [
        FacebookPixelService,
        {
          provide: 'facebookPixelConfig',
          useValue: config,
        },
      ],
    };
  }
}
